import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MarineInsuranceManagementModel } from '@data-layer/models/marine-insurance';
import { enumTransportationMode } from '@data-layer/enums/entry-summaries';
import { enumInsuranceShipmentType } from '@data-layer/enums/marine-insurance';

@Component({
  selector: 'app-marine-insurance-shipment-details-view-management-card',
  templateUrl: './marine-insurance-shipment-details-view-management-card.component.html',
  styleUrls: ['./marine-insurance-shipment-details-view-management-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsuranceShipmentDetailsViewManagementCardComponent {
  @Input() public marineInsurance: MarineInsuranceManagementModel;
  @Output() public edit: EventEmitter<void> = new EventEmitter<void>();

  public get transportationValue(): string {
    return (!!this.marineInsurance?.updatedTransportationMode
      ? this.marineInsurance?.updatedTransportationMode
      : this.marineInsurance?.transportationMode) === enumTransportationMode.OCEAN
      ? 'LABELS.OCEAN'
      : 'LABELS.AIR';
  }

  public get fromValue(): string {
    return !!this.marineInsurance?.updatedOriginCountry
      ? [this.marineInsurance?.updatedOriginCountry?.description, this.marineInsurance?.updatedOriginCity].join(', ')
      : [this.marineInsurance?.originCountry?.description, this.marineInsurance?.originCity].join(', ');
  }

  public get vesselNameValue(): string {
    return !!this.marineInsurance?.updatedVesselName ? this.marineInsurance?.updatedVesselName : this.marineInsurance?.vesselName;
  }

  public get packingTypeValue(): string {
    return `MARINE_INSURANCE_SHIPMENT_TYPE.${
      enumInsuranceShipmentType[
        !!this.marineInsurance?.updatedInsuredValue?.typeOfShipment
          ? this.marineInsurance?.updatedInsuredValue?.typeOfShipment
          : this.marineInsurance?.insuredValue?.typeOfShipment
      ]
    }`;
  }

  public get toValue(): string {
    return !!this.marineInsurance?.updatedDestinationCountry
      ? [this.marineInsurance?.updatedDestinationCountry?.description, this.marineInsurance?.updatedDestinationCity].join(', ')
      : [this.marineInsurance?.destinationCountry?.description, this.marineInsurance?.destinationCity].join(', ');
  }

  public get voyageNumberValue(): string {
    return !!this.marineInsurance?.updatedVoyageNumber ? this.marineInsurance?.updatedVoyageNumber : this.marineInsurance?.voyageNumber;
  }

  public get billNumber(): string {
    return `${
      !!this.marineInsurance?.updatedBillNumber?.carrier
        ? this.marineInsurance?.updatedBillNumber?.carrier
        : this.marineInsurance?.billNumber?.carrier
    }${
      !!this.marineInsurance?.updatedBillNumber?.number
        ? this.marineInsurance?.updatedBillNumber?.number
        : this.marineInsurance?.billNumber?.number
    }`;
  }

  public get shippingDateValue(): string {
    return !!this.marineInsurance?.updatedShippingDate ? this.marineInsurance?.updatedShippingDate : this.marineInsurance?.shippingDate;
  }

  public get vesselNameLabel(): string {
    return this.isOcean ? 'LABELS.VESSEL_NAME' : 'AIRLINE_PREFIX';
  }

  public get voyageNumberLabel(): string {
    return this.isOcean ? 'LABELS.VOYAGE_NUMBER' : 'FORM_LABEL.FLIGHT_NUMBER';
  }

  public get blLabel(): string {
    return this.isOcean ? 'LABELS.BL' : 'AWB';
  }

  public get isOcean(): boolean {
    return this.marineInsurance?.transportationMode === enumTransportationMode.OCEAN;
  }

  public get isUpdatedFrom(): boolean {
    return (
      (!!this.marineInsurance?.updatedOriginCountry?.description &&
        this.marineInsurance?.originCountry?.description !== this.marineInsurance?.updatedOriginCountry?.description) ||
      (!!this.marineInsurance?.updatedOriginCity && this.marineInsurance?.originCity !== this.marineInsurance?.updatedOriginCity)
    );
  }

  public get isUpdatedPackingType(): boolean {
    return (
      !!this.marineInsurance?.updatedInsuredValue?.typeOfShipment &&
      this.marineInsurance?.insuredValue?.typeOfShipment !== this.marineInsurance?.updatedInsuredValue?.typeOfShipment
    );
  }

  public get isUpdatedBL(): boolean {
    return (
      (!!this.marineInsurance?.updatedBillNumber?.carrier &&
        this.marineInsurance?.billNumber?.carrier !== this.marineInsurance?.updatedBillNumber?.carrier) ||
      (!!this.marineInsurance?.updatedBillNumber?.number &&
        this.marineInsurance?.billNumber?.number !== this.marineInsurance?.updatedBillNumber?.number)
    );
  }

  public get isUpdatedTo(): boolean {
    return (
      (!!this.marineInsurance?.updatedDestinationCountry?.description &&
        this.marineInsurance?.destinationCountry?.description !== this.marineInsurance?.updatedDestinationCountry?.description) ||
      (!!this.marineInsurance?.updatedDestinationCity &&
        this.marineInsurance?.destinationCity !== this.marineInsurance?.updatedDestinationCity)
    );
  }

  public isUpdatedPlainField(fieldA: string, fieldB: string): boolean {
    return this.marineInsurance?.[fieldA] !== this.marineInsurance?.[fieldB] && !!this.marineInsurance?.[fieldB];
  }
}
